import { Navigate, Outlet } from 'react-router-dom';
import { useSelector} from 'react-redux';


const NonAuthenticatedRoute = ({ redirectPath = '/index', children }) => {
    const {authenticated} = useSelector( state => state.userLogged);
        
    if (authenticated) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
};

export default NonAuthenticatedRoute;